var React = require('react');

function RotateLeft (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"points":"1 4 1 10 7 10","key":0}),React.createElement("path",{"d":"M3.51 15a9 9 0 1 0 2.13-9.36L1 10","key":1})]);
}

RotateLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-rotate-ccw"};

module.exports = RotateLeft;

RotateLeft.default = RotateLeft;
